import React, {FC} from "react";
import {ReactComponent as BeltIcon} from "../assets/icons/belt.svg";
import {ReactComponent as DateIcon} from "../assets/icons/date.svg";
import {ReactComponent as EngineIcon} from "../assets/icons/engine.svg";
import {ReactComponent as FanIcon} from "../assets/icons/fan.svg";
import {ReactComponent as GearboxIcon} from "../assets/icons/gearbox.svg";
import {ReactComponent as SpeedIcon} from "../assets/icons/speed.svg";
import {ReactComponent as MoTorCycleIcon} from "../assets/icons/motorcycle.svg";
import {ReactComponent as FacebookIcon} from "../assets/icons/facebook.svg";
import {IconNames} from "../enums/Icons";

const iconMap = {
    [IconNames.Belt]: BeltIcon,
    [IconNames.Date]: DateIcon,
    [IconNames.Engine]: EngineIcon,
    [IconNames.Fan]: FanIcon,
    [IconNames.Gearbox]: GearboxIcon,
    [IconNames.Speed]: SpeedIcon,
    [IconNames.MoTorCycle]: MoTorCycleIcon,
    [IconNames.Facebook]: FacebookIcon,
};

interface IGetSvgIcon {
    name: IconNames;
    className?: string;
    style?: React.CSSProperties;
}

export const GetSvgIcon: FC<IGetSvgIcon> = ({
    name,
    className,
    style,
}) => {

    // TODO use theme colors
    const IconComponent = iconMap[name] || null;
    if (!IconComponent) return <></>;

    const defaultStyle = {
        fill: "#9e9e9e",
        alignItems: "center",
        display: "flex",
        ...style,
    };
    return <IconComponent className={className} style={defaultStyle}/>;
};
